import Vue from 'vue'
import Router from 'vue-router'
import $store from './store'
import $i18n from './lib/i18n'

const Home = () => import('./pages/Home')
const InviteFriend = () => import('./pages/activity/InviteFriend')
const InviteRule = () => import('./pages/activity/InviteRule')
const NewYear = () => import('./pages/activity/NewYear')
const InvestedLanding = () => import('./pages/activity/InvestedLanding')
const Error = () => import('./pages/Error')
const CompanyProfile = () => import('./pages/CompanyProfile')
const Faq = () => import('./pages/Faq')
const Login = () => import('./pages/Login')
const Settings = () => import('./pages/Settings')
const Product = () => import('./pages/product/Product')
const FlexibleProduct = () => import('./pages/product/FlexibleProduct')
const InvestResult = () => import('./pages/product/InvestResult')
// const Signup = () => import('./pages/Signup')
const BindPhone = () => import('./pages/signup/BindPhone')
const SignupAdditional = () => import('./pages/signup/Additional')
const SignupResult = () => import('./pages/signup/Result')
const ForgetPassword = () => import('./pages/ForgetPassword')
const Overview = () => import('./pages/user/Overview')
const RecordList = () => import('./pages/user/RecordList')
const RecordDetail = () => import('./pages/user/RecordDetail')
const Ticket = () => import('./pages/user/Ticket')
const Borrower = () => import('./pages/user/Borrower')
const Security = () => import('./pages/user/Security')
const Topup = () => import('./pages/user/Topup')
const TopupResult = () => import('./pages/user/TopupResult')
const Transaction = () => import('./pages/user/Transaction')
const User = () => import('./pages/user/Index')
const Withdraw = () => import('./pages/user/Withdraw')
const AgreementPreview = () => import('./pages/user/AgreementPreview')
const OJK = () => import('./pages/OJK')
const Announcement = () => import('./pages/Announcement')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: async (to, from, next) => {
        next()
      },
    },
    {
      path: '/OJK',
      name: 'OJK',
      component: OJK,
    },
    {
      path: '/announcement',
      name: 'Announcement',
      component: Announcement,
    },
    {
      path: '/activity/landing/:channel?',
      name: 'InvestedLanding',
      component: InvestedLanding,
      meta: { nav: false },
    },
    {
      path: '/activity/invite',
      name: 'InviteFriend',
      component: InviteFriend,
    },
    {
      path: '/activity/invite/rule',
      name: 'InviteRule',
      component: InviteRule,
    },
    {
      path: '/activity/topup/newyear',
      name: 'NewYear',
      component: NewYear,
    },
    {
      path: '/error',
      name: 'Error',
      component: Error,
    },
    {
      path: '/company-profile',
      name: 'CompanyProfile',
      component: CompanyProfile,
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if ($store.getters.loggedin) {
          next('/')
          return
        }
        next()
      },
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: async (to, from, next) => {
        await $store.dispatch('logout')
        if (from.path === '/') {
          window.location.reload()
        }
        next('/')
      },
    },
    // App(IOS + Android) settings page for logout, can remove when they do not need
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      beforeEnter: async (to, from, next) => {
        if ($store.getters.loggedin) {
          $store.dispatch('reloadInvestor')
          if ($store.state.userInfo.status === 'ENABLED') {
            $store.dispatch('reloadAccount')
          }
        }
        next()
      },
    },
    {
      path: '/flexible-product',
      name: 'FlexibleProduct',
      component: FlexibleProduct,
      beforeEnter: async (to, from, next) => {
        if ($store.getters.loggedin) {
          $store.dispatch('reloadInvestor')
          if ($store.state.userInfo.status === 'ENABLED') {
            $store.dispatch('reloadAccount')
          }
        }
        next()
      },
    },
    {
      path: '/invest-result',
      name: 'InvestResult',
      component: InvestResult,
    },
    // {
    //   path: '/signup',
    //   name: 'Signup',
    //   component: Signup,
    //   beforeEnter: (to, from, next) => {
    //     if ($store.getters.loggedin) {
    //       next('/user/overview')
    //       return
    //     }
    //     next()
    //   },
    // },
    {
      path: '/bind-phone',
      name: 'BindPhone',
      component: BindPhone,
    },
    {
      path: '/signup-additional',
      name: 'SignupAdditional',
      component: SignupAdditional,
      beforeEnter: (to, from, next) => {
        if (!$store.getters.loggedin) {
          next('/login')
        }
        if (['PENDING', 'ENABLED'].includes($store.state.userInfo.status)) {
          if (from.path === '/signup-result') {
            next('/')
          } else {
            next('/signup-result')
          }
          return
        }
        $store.dispatch('reloadInvestor')
        next()
      },
    },
    {
      path: '/signup-result',
      name: 'SignupResult',
      component: SignupResult,
      beforeEnter: (to, from, next) => {
        $store.dispatch('reloadInvestor')
        next()
      },
    },
    {
      path: '/forget-password',
      name: 'ForgetPassword',
      component: ForgetPassword,
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      children: [
        {
          path: 'overview',
          name: 'UserOverview',
          component: Overview,
          beforeEnter: (to, from, next) => {
            $store.dispatch('reloadInvestor')
            if ($store.state.userInfo.status === 'ENABLED') {
              $store.dispatch('reloadAccount')
            }
            next()
          },
        },
        {
          path: 'record-list/:type',
          name: 'UserRecordList',
          component: RecordList,
          meta: { userNav: false },
        },
        {
          path: 'record-detail/:type',
          name: 'UserRecordDetail',
          component: RecordDetail,
          meta: { userNav: false },
          beforeEnter: (to, from, next) => {
            if ($store.state.userInfo.status !== 'ENABLED' || !$store.getters.loggedin) {
              next('/user/overview')
            }
            next()
          },
        },
        {
          path: 'Ticket',
          name: 'UserTicket',
          component: Ticket,
          beforeEnter: (to, from, next) => {
            $store.dispatch('reloadCouponList')
            next()
          },
        },
        {
          path: 'borrower',
          name: 'UserBorrower',
          component: Borrower,
        },
        {
          path: 'security',
          name: 'UserSecurity',
          component: Security,
          beforeEnter: (to, from, next) => {
            $store.dispatch('reloadInvestor', { force: false })
            next()
          },
        },
        {
          path: 'topup',
          name: 'UserTopup',
          component: Topup,
        },
        {
          path: 'topup-result',
          name: 'UserTopupResult',
          component: TopupResult,
        },
        {
          path: 'transaction',
          name: 'UserTransaction',
          component: Transaction,
        },
        {
          path: 'withdraw',
          name: 'UserWithdraw',
          component: Withdraw,
          beforeEnter: (to, from, next) => {
            $store.dispatch('reloadInvestor', { force: false })
            next()
          },
        },
        {
          path: 'agreement-preview',
          name: 'AgreementPreview',
          component: AgreementPreview,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  // App conditions for route change, can remove when they do not need
  if (window.bridge) {
    if (window.bridge.appLoggedin) {
      const appLogged = window.bridge.appLoggedin()
      if (appLogged) {
        await Promise.all([
          $store.dispatch('reloadInvestor'),
          $store.dispatch('reloadAccount'),
        ])
      }
    }
    if (window.bridge.appInfo) {
      const appInfoStr = window.bridge.appInfo()
      try {
        const appInfo = JSON.parse(appInfoStr)
        const appLanguage = appInfo.appLanguage
        if (appLanguage !== $store.state.locale) {
          $store.commit('updateLocale', appLanguage)
          $i18n.locale = appLanguage
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (window.bridge.onRouteChanged) {
      const origin = `${location.protocol}//${location.host}`
      const shouldRoute = window.bridge.onRouteChanged(`${origin}${from.fullPath}`, `${origin}${to.fullPath}`)
      if (shouldRoute) {
        return
      }
    }
  }
  if ($store.getters.loggedin && !$store.state.userInfo.mobileNumber && to.path !== '/bind-phone') {
    next('/bind-phone')
  }
  if ($store.getters.loggedin && !window.bridge) {
    const timeStamp = Vue.prototype.moment().format('YYYYMMDD')
    if (localStorage.getItem('couponPopupDate') !== timeStamp) {
      $store.dispatch('reloadCouponList')
    }
  }
  next()
})

export default router
